import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { Router } from "@angular/router"
import { BaseService, ErroresService, AppEnv } from "@puntaje/shared/core"
import { PuntajeAuthService } from "./puntaje_auth.service"
import { SmowlObject } from "./smowl_object.model"

@Injectable()
export class Smowls extends BaseService<SmowlObject> {
    tableName = "smowl/usuarios"
    singularTableName = "smowl_object"
    modelClass = SmowlObject

    constructor(
        protected http: HttpClient,
        protected auth: PuntajeAuthService,
        protected router: Router,
        protected errores: ErroresService,
        protected environment: AppEnv
    ) {
        super(http, auth, router, errores, environment)
    }

    public confirmRegistration(id: number) {
        return this.one(id).concatExtra("confirm_registration").get()
    }
}
